// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Caption/Caption.sass
// module id = 351
// module chunks = 0